import React, { useState, useEffect, useCallback, useRef } from "react";
import { Col, Container, Row } from "rsuite";
import {
	getCTSFilterData,
	getCTSScatterData,
	getCTSSummaryData,
} from "../../queries/ScenarioForecast";
import "./costToServe.scss";
import Table from "../../components/CostToSellComponents/CustomerSummaryTable";
import ScatterGraph from "../../components/CostToSellComponents/GraphComponent";
import MainHeader from "../../components/Layouts/MainHeader";
import Heading from "../../components/common/Heading";
import MainContent from "../../components/Layouts/MainContent";
import FilterComponent from "../../components/common/FilterComponent";
import uparrowFilter from "../../assets/uparrowFilter.svg";
import downarrowFilter from "../../assets/downarrowFilter.svg";
import CustomLoader from "../../components/custom-loader";

import { useLocation } from "react-router-dom";
import useFilter from "../../hooks/useFilter";
import FilterComponentCreator from "../../components/common/FilterComponent/FilterComponentCreator";
import { CostToServeFilterConfig, filterDefaultValues } from "./CostToServeFilterConfig";
const CostToServe = () => {
	const [state, setState] = useState({
		pageLoading: 0,
		ClearScenarioTable: false,
		tableHeight: 250,
		expendedRow: [],
		userEmail: localStorage.getItem("user_email"),
		pageSize: 10,
		PageNumber: 1,
		orderBy: "revenue",
		TableSummaryData: [],
		order: "desc",
		setOrderForSorting: null,
		mainData: [],
		graphData: [],
		graphData2: [],
		customerList: null,
		customerScenarioData: null,
		selectedCustomer: null,
		selectedCustomerTable: null,
		powerBiSelectedCustomer: 0,
		selectedCustomerName: "",
		customerData: [],
		customerRowExpand: [],
		locationRowExpand: [],
		isGoBackLinkVisible: false,
		setGoBackLinkValue: null,
		showHeader: false,
		customEnteredDropValue: 0,
		CustomDelieveryFees: 0,
		CustomAvgDropSize: 0,
		CustomDM: 0,
		CustomGM: 0,
		CustomOpportunity: 0,
		CustomDropDays: "",
		selectedScenarioList: [],
		openPopUp: false,
		selectedCustomerId: 0,
		hideAddScenarioButton: false,
		isCheckBoxChecked: true,
		selectedScenarioData: null,
		selectedCustomerCTS: 0,
		selectedCustomerActualDrop: 0,
		currentScenarioData: null,
		thresholdX: 0,
		thresholdY: 0,
		DataShow: false,
		totalPages: 0,
		filterData: {
			District: ["All"],
		},
	});
	const [filterExpansion, setfilterExpansion] = useState(true);
	const [categoryFilterValue, setCategoryFilterValue] = useState<any[]>([]);

	const setExpendedRowArray = (val = [], id: any) => {
		setState((prevState) => ({
			...prevState,
			expendedRow: val,
			selectedCustomer: id,
			selectedCustomerTable: id,
		}));
	};
	const { selectedFilter } = useFilter();

	const getGraphData = useCallback(
		(data: any) => {
			setState((prevState) => ({
				...prevState,
				pageLoading: prevState.pageLoading + 1,
			}));
			getCTSScatterData({
				...data,
				userEmail: state.userEmail,
			}, selectedFilter)
				.then((response) => {
					if (response?.status === 200) {
						setState((prevState) => ({
							...prevState,
							graphData2: response?.data?.scatterData.filter(((d: any) => {
								//!static for now need to remove in future
								return !(d.revenueperdrop > 743000 || d.revenueperdrop == 0 || d.ctsperdrop < -44000)
							})),
							pageLoading: prevState.pageLoading - 1,
							thresholdX:
								response?.data?.avgData[0]?.avg_revenueperdrop,
							thresholdY:
								response?.data?.avgData[0]?.avg_ctsperdrop,
						}));
					} else {
						setState((prevState) => ({
							...prevState,
							pageLoading: prevState.pageLoading - 1,
						}));
					}
				})
				.catch((err) => {
					setState((prevState) => ({
						...prevState,
						pageLoading: prevState.pageLoading - 1,
					}));
					console.log(err);
				});
		},
		[state.userEmail]
	);

	const getCTSSummaryDataHandler = useCallback((data: any) => {
		setState((prevState) => ({
			...prevState,
			pageLoading: prevState.pageLoading + 1,
			DataShow: true,
		}));
		getCTSSummaryData(data, selectedFilter)
			.then((res) => {
				if (res?.status === 200) {
					setState((prevState) => ({
						...prevState,
						TableSummaryData: res?.data?.data,
						totalPages: res?.data?.totalCustomerCount,
						pageLoading: prevState.pageLoading - 1,
						ClearScenarioTable: false,
					}));
				} else {
					setState((prevState) => ({
						...prevState,
						pageLoading: prevState.pageLoading - 1,
					}));
				}
			})
			.catch((err) => {
				console.log(err);
				setState((prevState) => ({
					...prevState,
					pageLoading: prevState.pageLoading - 1,
				}));
			});
	}, []);

	const handleScatterClick = (data: any) => {
		setState((prevState) => ({ ...prevState, DataShow: true }));
		if (state.selectedCustomer === data) {
			getCTSSummaryDataHandler({
				customer: ["All"],
				customer_desc: [],
				pageNumber: state.PageNumber,
				...filterValues,
				userEmail: state.userEmail,
				pageSize: state.pageSize,
				order: state.order,
				orderBy: state.orderBy,
			});
		} else {
			getCTSSummaryDataHandler({
				customer: [data],
				customer_desc: [],
				pageNumber: state.PageNumber,
				...filterValues,
				userEmail: state.userEmail,
				pageSize: state.pageSize,
				order: state.order,
				orderBy: state.orderBy,
			});
			setState((prevState) => ({
				...prevState,
				selectedCustomer: data,
				selectedCustomerId: data,
				showHeader: false,
				ClearScenarioTable: true,
				hideAddScenarioButton: false,
				selectedScenarioList: [],
				customEnteredDropValue: 0,
				CustomDelieveryFees: 0,
				CustomAvgDropSize: 0,
				CustomDM: 0,
				CustomGM: 0,
				CustomOpportunity: 0,
				CustomDropDays: "",
				selectedCustomerCTS: data.pricePerCase,
				selectedCustomerActualDrop: data.noOfDropsPerWeek,
			}));
		}
	};

	const handlePaginationAPI = (pageSize: any, PageNumber: any) => {
		setState((prevState) => ({ ...prevState, pageSize, PageNumber }));
		const payload = {
			customer_desc: [],
			pageNumber: PageNumber,
			...filterValues,
			userEmail: state.userEmail,
			pageSize: pageSize,
			order: state.order,
			orderBy: state.orderBy,
		};
		getCTSSummaryDataHandler(payload);
	};
	const [filterResponse, setFilterResponse] = useState();
	const getFilterData = useCallback(() => {
		setState((prevState: any) => ({
			...prevState,
			pageLoading: prevState.pageLoading + 1,
		}));
		getCTSFilterData({
			district: ["{}"],
		}, selectedFilter)
			.then((response: any) => {
				setState((prevState: any) => ({
					...prevState,
					pageLoading: prevState.pageLoading - 1,
				}));
				if (response.status === 200) {
					const filterDataGlobal = response.data;
					setFilterResponse(filterDataGlobal)
				}
			})
			.catch(() => {
				setState((prevState: any) => ({
					...prevState,
					pageLoading: prevState.pageLoading - 1,
				}));
			});
	}, []);
	const [filterValues, setFilterValues] = useState(filterDefaultValues[selectedFilter]);

	const handleFilterSelection = (key: string, value: any) => {
		getGraphData({
			customer: [],
			[key]: value,
		});
		getCTSSummaryDataHandler({
			customer: ["All"],
			customer_desc: [],
			pageNumber: state.PageNumber,
			userEmail: state.userEmail,
			pageSize: state.pageSize,
			order: state.order,
			orderBy: state.orderBy,
			[key]: value,
		});
		setFilterValues((prev: any) => ({ ...prev, [key]: value }))
	};

	// Use a ref to track initial load
	const initialLoad = useRef(true);

	useEffect(() => {
		if (initialLoad.current) {
			initialLoad.current = false;
			getFilterData();
			const arr = window.location.hash.split("?");
			if (arr.length > 1) {
				const queryParams = arr[1].split("&");
				window.localStorage.setItem(
					"navigateTo",
					arr[0] + "?" + queryParams[0]
				);
				if (queryParams[1] === "close=true") {
					window.close();
				}
			}
			const id = document.getElementById("graph");
			if (id) {
				setState((prevState) => ({
					...prevState,
				}));
			}
			setState((prevState) => ({
				...prevState,
				tableHeight: window.innerHeight - 250,
			}));
			getGraphData({
				...filterValues,
				customer: [],
			});
			getCTSSummaryDataHandler({
				customer: ["All"],
				customer_desc: [],
				pageNumber: state.PageNumber,
				...filterValues,
				userEmail: state.userEmail,
				pageSize: state.pageSize,
				order: state.order,
				orderBy: state.orderBy,
			});
		}
	}, []); // Empty dependency array ensures this runs only once

	const { pageLoading, graphData2, thresholdX, thresholdY } = state;
	const loctaionValue = useLocation();
	useEffect(() => {
		const searchedDistrict = new URLSearchParams(loctaionValue.search).get(
			"district"
		);

		if (searchedDistrict && selectedFilter == "electrical") {
			handleFilterSelection("district", [searchedDistrict])
		}
	}, []);
	return (
		<>
			{pageLoading > 0 && (
				<div>
					<CustomLoader open={true} />
				</div>
			)}
			<>
				<MainHeader customClass="relative" headerName="Cost To Serve">
					<div className="w-full">
						{filterExpansion && (
							<div className="grid grid-cols-8 justify-start items-center gap-8 pb-[2vh]">
								<div className="flex flex-col justify-start items-start">
									<FilterComponentCreator config={CostToServeFilterConfig[selectedFilter]} data={filterResponse} handleFilterValueChange={handleFilterSelection} values={filterValues} />
								</div>
							</div>
						)}
					</div>
					{filterExpansion ? (
						<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
							<img
								className="w-[1.5vw]"
								src={uparrowFilter}
								alt="upArrow"
								onClick={() => {
									setfilterExpansion(false);
								}}
							/>
						</div>
					) : (
						<div className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer">
							<img
								className="w-[1.5vw]"
								src={downarrowFilter}
								alt="upArrow"
								onClick={() => {
									setfilterExpansion(true);
								}}
							/>
						</div>
					)}
				</MainHeader>
				<MainContent
					className="bg-[#F1F1F1]"
					fullHeight={!filterExpansion}
				>
					<div className="flex gap-[2%] items-center">
						<div className="chart-title subHeadleft">
							{"Cost To Serve(CTS) Vs Drop Value for Customers"}
						</div>
						<div className="chart-title subHeadright">{"Customer Summary"}</div>
					</div>
					<Row className="show-grid">
						<Col className={`w-[39%] `}>
							<div
								className={`container-border bg-white ${filterExpansion ? "h-[60vh]" : "h-[68vh]"
									}`}
								id="graph"
							>
								<ScatterGraph
									thresholdY={thresholdY}
									thresholdX={thresholdX}
									selectedCustomer={state.selectedCustomer}
									graphData={graphData2}
									handleScatterClick={handleScatterClick}
									filterExpansion={filterExpansion}
								/>
							</div>
						</Col>
						<Col
							className={`w-[59%]  ml-[1%] ${filterExpansion ? "h-[60vh]" : "h-[68vh]"
								}`}
						>
							{state.DataShow ? (
								<>
									<Table
										totalPages={state.totalPages}
										handlePaginationAPI={
											handlePaginationAPI
										}
										ClearScenarioTable={
											state.ClearScenarioTable
										}
										setExpendedRowArray={
											setExpendedRowArray
										}
										expandedRows={state.expendedRow}
										TableSummaryData={
											state.TableSummaryData
										}
										sortData={{
											pageSize: 10,
											PageNumber: 1,
											orderBy: "marginOpportunity",
											order: "desc",
											setOrderForSorting: null,
										}}
									/>{" "}
								</>
							) : (
								<></>
							)}
						</Col>
					</Row>
				</MainContent>
			</>
		</>
	);
};

export default CostToServe;
